



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AppFooter extends Vue {
  private links = [
    'Home',
    'About Us',
    'Team',
    'Services',
    'Blog',
    'Contact Us',
  ];
}
